<app-page [inTutorial]="true">
  <trade-creator [inTutorial]="true" [tutorialBuy]="false"></trade-creator>
</app-page>
